"use client";
import NavbarOne from "./navbar-one";

const Header = () => {
  return <NavbarOne />;
};

export default Header;
